App = App || {};

App.PromotionDetail = (function ($, Vue) {
	"use strict";

	var $modal;
	function init(rootElement) {
		rootElement = rootElement || document.getElementById("promotion-detail-app");

		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = "1";

		$modal = $(rootElement).closest(".modal");

		new Vue({
			el: rootElement,
			data: {
				isNew: false,
				isLoading: false,
				isSaving: false,
				isSaved: false,
				alertMessage: "",
				alertErrors: [],
				items: [],
				onlySelectedItems: false,
				itemSearchTerm: "",
				itemLiveAnnounce: "",
				itemGroups: [],
				memberRoles: [],
				dealers: [],
				onlySelectedDealers: false,
				dealerSearchTerm: "",
				dealerLiveAnnounce: "",
				itemGroupLiveAnnounce: "",
				courseRoleDefs: [],
				promotion: {
					dealers: [],
					itemGroups: [],
					items: [],
					roles: []
				},
			},

			computed: {
				hasSerials: function () {
					return Array.isArray(this.promotion.serials) && this.promotion.serials.length > 0;
				},

				startsComputed: {
					get: function () {
						var startDate = this.promotion.startDate;
						if (!startDate)
							return "";

						var startDateString = String(startDate);
						if (startDateString.length >= 10 && /^\d{4}-\d{2}-\d{2}$/.test(startDateString.slice(0, 10)))
							return startDateString.slice(0, 10);

						var normalized = startDateString.replace(/(\.\d{3})\d+$/, "$1");
						var normalizedDate = new Date(normalized);
						if (isNaN(normalizedDate))
							return "";

						var monthPart = String(normalizedDate.getMonth() + 1).padStart(2, "0");
						var dayPart = String(normalizedDate.getDate()).padStart(2, "0");
						return normalizedDate.getFullYear() + "-" + monthPart + "-" + dayPart;
					},
					set: function (value) {
						var current = this.promotion.startDate ? String(this.promotion.startDate) : "";
						var timePart = current.indexOf("T") > -1 ? current.split("T")[1] : "00:00:00";
						this.promotion.startDate = value ? (value + "T" + timePart) : null;
					}
				},

				endsComputed: {
					get: function () {
						var endDate = this.promotion.endDate;
						if (!endDate)
							return "";

						var endDateString = String(endDate);
						if (endDateString.length >= 10 && /^\d{4}-\d{2}-\d{2}$/.test(endDateString.slice(0, 10)))
							return endDateString.slice(0, 10);

						var normalized = endDateString.replace(/(\.\d{3})\d+$/, "$1");
						var normalizedDate = new Date(normalized);
						if (isNaN(normalizedDate))
							return "";

						var monthPart = String(normalizedDate.getMonth() + 1).padStart(2, "0");
						var dayPart = String(normalizedDate.getDate()).padStart(2, "0");
						return normalizedDate.getFullYear() + "-" + monthPart + "-" + dayPart;
					},
					set: function (value) {
						var current = this.promotion.endDate ? String(this.promotion.endDate) : "";
						var timePart = current.indexOf("T") > -1 ? current.split("T")[1] : "00:00:00";
						this.promotion.endDate = value ? (value + "T" + timePart) : null;
					}
				},

				hasItemGroupFilter: function () {
					return this.promotion &&
						Array.isArray(this.promotion.itemGroups) &&
						this.promotion.itemGroups.length > 0;
				},

				selectedDealerIds: function () {
					var set = Object.create(null);
					if (this.promotion && Array.isArray(this.promotion.dealers)) {
						for (var i = 0; i < this.promotion.dealers.length; i++) {
							set[this.promotion.dealers[i].id] = 1;
						}
					}
					return set;
				},

				filteredDealers: function () {
					var term = String(this.dealerSearchTerm).toLowerCase();
					var base = this.onlySelectedDealers ?
						this.dealers.filter(d => this.selectedDealerIds[d.id] === 1) :
						this.dealers;

					var list = term ?
						base.filter(function (dealer) {
							return (dealer.cardName && dealer.cardName.toLowerCase().indexOf(term) !== -1)
								|| (dealer.bpCode && dealer.bpCode.toLowerCase().indexOf(term) !== -1);
						}) :
						base.slice(0);

					return list;
				},

				selectedItemIds: function () {
					var set = Object.create(null);
					if (this.promotion && Array.isArray(this.promotion.items)) {
						for (var i = 0; i < this.promotion.items.length; i++) {
							set[this.promotion.items[i].id] = 1;
						}
					}
					return set;
				},

				selectedItemGroups: function () {
					var set = Object.create(null);
					if (this.promotion && Array.isArray(this.promotion.itemGroups)) {
						for (var i = 0; i < this.promotion.itemGroups.length; i++) {
							set[this.promotion.itemGroups[i]] = 1;
						}
					}
					return set;
				},

				selectedItemCount: function () {
					if (!this.hasItemGroupFilter)
						return (this.promotion && Array.isArray(this.promotion.items)) ? this.promotion.items.length : 0;

					var groupSet = this.selectedItemGroups;

					var itemHash = Object.create(null);
					for (var i = 0; i < this.items.length; i++) {
						itemHash[this.items[i].id] = this.items[i];
					}

					var itemCount = 0;
					if (this.promotion && Array.isArray(this.promotion.items)) {
						for (var j = 0; j < this.promotion.items.length; j++) {
							var full = itemHash[this.promotion.items[j].id];
							if (full && full.itemGroup && groupSet[full.itemGroup] === 1) {
								itemCount++;
							}
						}
					}
					return itemCount;
				},

				filteredItems: function () {
					var term = String(this.itemSearchTerm).toLowerCase();
					var base = this.onlySelectedItems ?
						this.items.filter(d => this.selectedItemIds[d.id] === 1) :
						this.items;

					var groupSet = this.selectedItemGroups;
					if (this.hasItemGroupFilter) {
						base = base.filter(function (item) {
							return item.itemGroup && groupSet[item.itemGroup] === 1;
						});
					}

					var list = term ?
						base.filter(function (item) {
							return (item.description && item.description.toLowerCase().indexOf(term) !== -1)
								|| (item.sonaItemNo && item.sonaItemNo.toLowerCase().indexOf(term) !== -1);
						}) :
						base.slice(0);

					return list;
				}
			},

			methods: {
				_initTooltips: function () {
					$modal.find('[data-toggle="tooltip"]').tooltip('dispose');
					$modal.find('[data-toggle="tooltip"]').tooltip({
						container: 'body',
						trigger: 'hover focus',
						boundary: 'viewport',
						html: false
					});
				},

				formatDate: function (value) {
					if (!value)
						return "";
					var normalized = String(value).replace(/(\.\d{3})\d+$/, "$1");
					var d = new Date(normalized);
					return isNaN(d) ? String(value) : d.toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
				},

				clearState: function () {
					this.isNew = false;
					this.isLoading = false;
					this.isSaved = false;
					this.isSaving = false;
					this.alertMessage = "";
					this.alertErrors = [];
					this.promotion = {
						dealers: [],
						itemGroups: [],
						items: [],
						roles: []
					};
				},

				close: function () {
					$modal.modal("hide");
				},

				loadPromotion: function () {
					var id = $modal.data("id");

					if (!id) {
						this.isNew = true;
						return;
					}

					return $.ajax({
						url: "/api/promotions/" + encodeURIComponent(id),
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 15000
					})
						.done((resp) => {
							if (resp && resp.success && resp.data) {
								this.promotion = resp.data;
							} else {
								this.alertMessage = (resp && resp.message) || "Unable to load item.";
							}
						})
						.fail((jqXHR, status) => {
							this.alertMessage = (jqXHR && jqXHR.status === 404) ? "Item not found (404)." :
								(status === "timeout" ? "Request timed out." : "Failed to load item.");
						});
				},

				loadItemGroups: function () {
					return $.ajax({
						url: "/api/lookups/item_groups",
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 10000
					}).done((resp) => {
						if (resp && resp.success && Array.isArray(resp.data)) {
							this.itemGroups = resp.data;
						} else {
							this.itemGroups = [];
						}
					}).fail(() => {
						this.itemGroups = [];
					});
				},

				loadItems: function () {
					return $.ajax({
						url: "/api/items/active",
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 10000
					}).done((resp) => {
						if (resp && resp.success && Array.isArray(resp.data)) {
							this.items = resp.data;
						} else {
							this.items = [];
						}
					}).fail(() => {
						this.items = [];
					});
				},

				loadDealers: function () {
					return $.ajax({
						url: "/api/dealers/all",
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 10000
					}).done((resp) => {
						if (resp && resp.success && Array.isArray(resp.data)) {
							this.dealers = resp.data;
						} else {
							this.dealers = [];
						}
					}).fail(() => {
						this.dealers = [];
					});
				},

				isItemGroupSelected: function (itemGroup) {
					if (!(this.promotion && Array.isArray(this.promotion.itemGroups)))
						return false;

					for (var i = 0; i < this.promotion.itemGroups.length; i++) {
						if (this.promotion.itemGroups[i] === itemGroup)
							return true;
					}
					return false;
				},

				isItemSelected: function (id) {

					if (!(this.promotion && Array.isArray(this.promotion.items)))
						return false;

					for (var i = 0; i < this.promotion.items.length; i++) {
						if (this.promotion.items[i].id === id)
							return true;
					}
					return false;
				},

				toggleItem: function (item) {
					if (this.isItemSelected(item.id)) {
						this.removeItem(item.id);
					} else {
						this.addItem(item);
					}
				},

				addItem: function (item) {
					if (!this.promotion.items)
						this.promotion.items = [];

					for (var i = 0; i < this.promotion.items.length; i++) {
						if (this.promotion.items[i].id === item.id)
							return;
					}

					this.promotion.items.push({
						id: item.id,
						description: item.description,
						sonaItemNo: item.sonaItemNo
					});

					this.itemLiveAnnounce = "Added " + (item.description || "item");
				},

				removeItem: function (id) {
					if (!this.promotion.items)
						return;

					for (var i = 0; i < this.promotion.items.length; i++) {
						if (this.promotion.items[i].id === id) {
							var description = this.promotion.items[i].description;
							this.promotion.items.splice(i, 1);
							this.itemLiveAnnounce = "Removed " + (description || "item");
							break;
						}
					}
				},

				toggleItemGroup: function (itemGroup) {
					if (this.isItemGroupSelected(itemGroup)) {
						this.removeItemGroup(itemGroup);
					} else {
						this.addItemGroup(itemGroup);
					}
				},

				addItemGroup: function (itemGroup) {
					if (!this.promotion.itemGroups)
						this.promotion.itemGroups = [];

					for (var i = 0; i < this.promotion.itemGroups.length; i++) {
						if (this.promotion.itemGroups[i] === itemGroup)
							return;
					}

					this.promotion.itemGroups.push(itemGroup);

					this.dealerLiveAnnounce = "Added " + (itemGroup || "item group");
				},

				removeItemGroup: function (itemGroup) {
					if (!this.promotion.itemGroups)
						return;

					for (var i = 0; i < this.promotion.itemGroups.length; i++) {
						if (this.promotion.itemGroups[i] === itemGroup) {
							var name = this.promotion.itemGroups[i];
							this.promotion.itemGroups.splice(i, 1);
							this.dealerLiveAnnounce = "Removed " + (name || "item group");
							break;
						}
					}
				},

				isDealerSelected: function (id) {

					if (!(this.promotion && Array.isArray(this.promotion.dealers)))
						return false;

					for (var i = 0; i < this.promotion.dealers.length; i++) {
						if (this.promotion.dealers[i].id === id)
							return true;
					}
					return false;
				},

				toggleDealer: function (dealer) {
					if (this.isDealerSelected(dealer.id)) {
						this.removeDealer(dealer.id);
					} else {
						this.addDealer(dealer);
					}
				},

				addDealer: function (dealer) {
					if (!this.promotion.dealers)
						this.promotion.dealers = [];

					for (var i = 0; i < this.promotion.dealers.length; i++) {
						if (this.promotion.dealers[i].id === dealer.id)
							return;
					}

					this.promotion.dealers.push({
						id: dealer.id,
						cardName: dealer.cardName,
						bpCode: dealer.bpCode
					});

					this.dealerLiveAnnounce = "Added " + (dealer.cardName || "dealer");
				},

				removeDealer: function (id) {
					if (!this.promotion.dealers)
						return;

					for (var i = 0; i < this.promotion.dealers.length; i++) {
						if (this.promotion.dealers[i].id === id) {
							var name = this.promotion.dealers[i].cardName;
							this.promotion.dealers.splice(i, 1);
							this.dealerLiveAnnounce = "Removed " + (name || "dealer");
							break;
						}
					}
				},

				clearSelected: function () {
					this.promotion.dealers = [];
					this.dealerLiveAnnounce = "Removed all dealers";
				},

				loadMemberRoles: function () {
					return $.ajax({
						url: "/api/lookups/member_roles",
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 10000
					}).done((resp) => {
						if (resp && resp.success && Array.isArray(resp.data)) {
							this.memberRoles = resp.data;
						} else {
							this.memberRoles = [];
						}
					}).fail(() => {
						this.memberRoles = [];
					});
				},

				loadCourseRoleDefs: function () {
					return $.ajax({
						url: "/api/lookups/course-roles",
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 10000
					}).done((resp) => {
						if (resp && resp.success && Array.isArray(resp.data)) {
							this.courseRoleDefs = resp.data;
						} else {
							this.courseRoleDefs = [];
						}
					}).fail(() => {
						this.courseRoleDefs = [];
					});
				},

				savePromotion: function () {
					if (!this.promotion || !this.promotion.id)
						return;

					this.isSaving = true;
					this.alertMessage = "";
					this.isSaved = false;

					$.ajax({
						url: "/api/promotions",
						method: "PUT",
						contentType: "application/json; charset=utf-8",
						dataType: "json",
						data: JSON.stringify(this.promotion),
						headers: { "Accept": "application/json" },
						timeout: 15000
					}).done((resp) => {
						if (resp && resp.success && resp.data) {
							this.promotion = resp.data;
							this.isSaved = true;
							setTimeout(() => {
								this.close();
							}, 900);
						} else {
							this.alertMessage = (resp && resp.message) || "Save failed.";
						}
					}).fail((jqXHR, status) => {
						this.alertMessage = (jqXHR && jqXHR.status === 404) ? "Endpoint not found (404)." :
							(status === "timeout" ? "Request timed out." : "Save failed.");
					}).always(() => {
						this.isSaving = false;
					});
				},

				createPromotion: function () {
					if (!this.promotion)
						return;

					this.isSaving = true;
					this.alertMessage = "";
					this.isSaved = false;

					$.ajax({
						url: "/api/promotions",
						method: "POST",
						contentType: "application/json; charset=utf-8",
						dataType: "json",
						data: JSON.stringify(this.promotion),
						headers: { "Accept": "application/json" },
						timeout: 15000
					}).done((resp) => {
						if (resp && resp.success && resp.data) {
							this.promotion = resp.data;
							this.isSaved = true;
							setTimeout(() => {
								this.close();
							}, 900);
						} else {
							this.alertMessage = (resp && resp.message) || "Create failed.";
						}
					}).fail((jqXHR, status) => {
						this.alertMessage = (jqXHR && jqXHR.status === 404) ? "Endpoint not found (404)." :
							(status === "timeout" ? "Request timed out." : "Create failed.");
					}).always(() => {
						this.isSaving = false;
					});
				},

				deletePromotion: function () {
					if (!this.promotion || !this.promotion.id)
						return;

					var ok = window.confirm('Are you sure you want to delete this promotion? This cannot be undone.');
					if (!ok)
						return;

					this.isSaving = true;
					this.alertMessage = "";
					this.isSaved = false;

					$.ajax({
						url: `/api/promotions/${encodeURIComponent(this.promotion.id)}`,
						method: "DELETE",
						contentType: "application/json; charset=utf-8",
						dataType: "json",
						data: JSON.stringify(this.promotion),
						headers: { "Accept": "application/json" },
						timeout: 15000
					}).done((resp) => {
						if (resp && resp.success) {
							this.isSaved = true;
							setTimeout(() => {
								this.close();
							}, 900);
						} else {
							this.alertMessage = (resp && resp.message) || "Delete failed.";
						}
					}).fail((jqXHR, status) => {
						this.alertMessage = (jqXHR && jqXHR.status === 404) ? "Endpoint not found (404)." :
							(status === "timeout" ? "Request timed out." : "Delete failed.");
					}).always(() => {
						this.isSaving = false;
					});
				}


			},

			mounted: function () {
				$modal.off("show.bs.modal hidden.bs.modal");

				$modal.on("show.bs.modal", () => {
					this.clearState();
					this.isLoading = true;

					$.when(
						this.loadPromotion(),
						this.loadItemGroups(),
						this.loadCourseRoleDefs(),
						this.loadMemberRoles(),
						this.loadDealers(),
						this.loadItems()
					).always(() => {
						this.isLoading = false;
					});
				});

				$modal.on("shown.bs.modal", () => {
					$modal.find("#close-icon").focus();
				});

				this.$nextTick(this._initTooltips);
			}
		});
	}

	function create(onClose) {
		$modal.data("id", null).modal("show");

		if (onClose) {
			$modal.one('hidden.bs.modal', onClose);
		}
	}
	function open(id, onClose) {
		$modal.data("id", id).modal("show");

		if (onClose) {
			$modal.one('hidden.bs.modal', onClose);
		}
	}

	return {
		init: init,
		open: open,
		create: create
	};
})(jQuery, Vue);

App.PromotionDetail.init();